$(function() {
    function getPhoneContainer(element) {
        return element.parents('.phoneContainer');
    }

    function addPhone() {
        var additionalPhoneIndex;
        for (var i = 1; i <= 4; i++) {
            if ($('[data-phone-index=' + i + ']').length < 1) {
                additionalPhoneIndex = i;
                break;
            }
        }

        var phoneAction = $('#additionalPhones').data('add-url');
        phoneAction = phoneAction.replace('__NO__', additionalPhoneIndex);

        if (additionalPhoneIndex) {
            $.ajax({
                url: phoneAction
            }).done(function(data) {
                var html = $(data);
                $('#additionalPhones').append(html).show();
                if ($('.phoneContainer').length > 4) {
                    $('#addPhone').hide();
                }
            });
        }
    }

    function removePhone(phone) {
        const phoneId = $(phone).data('remove');
        $('#addPhone').show();
        $('#phoneInputHolder' + phoneId).remove();
        $('#addPhoneJavascript').show();
    }

    function getNumberField(element) {
        if (getPhoneContainer(element).find('input[id$=_phone_number]').length > 0) {
            return getPhoneContainer(element).find('input[id$=_phone_number]');
        }
        return getPhoneContainer(element).find('input[id$=_phone]');
    }

    function getPhoneType(element) {
        var phoneType = getPhoneContainer(element).find('select[id$=_phone_type]');

        if (phoneType.length > 0) {
            return phoneType.val();
        }

        return false;
    }

    function getCountryCode() {
        var countrySelect = $('select[id$=_country]');
        var countryCode;

        if (countrySelect.length > 0 && countrySelect.val()) {
            countryCode = countrySelect.find('option:selected').data('phone-code');
        }

        if (!countryCode) {
            countryCode = '385';
        }

        return countryCode;
    }

    function changeCountry() {
        $('input[id$=_phone_number]').each(function() {
            if($(this).val().length < 5) {
                changePhoneType($(this));
            }
        });
    }

    function changePhoneType(element) {
        var countryCode = getCountryCode();

        // talijanski telefonski brojevi moraju imati nulu nakon country code-a
        if (getPhoneType(element) != 3 && countryCode == '39') {
            countryCode = '390';
        }

        getNumberField(element).val('+' + countryCode);
    }

    $(document).on('change', 'select[id$=_country]', function() { changeCountry(); });
    $(document).on('click', '.removePhone', function () { removePhone(this)});
    $('#addPhone').on('click', function () { addPhone()});
});
